import { useSelector, shallowEqual } from 'react-redux';

export default function useAccount() {
  const accountId = useSelector((store) => store.accountId, shallowEqual);
  const accounts = useSelector((store) => store.accounts, shallowEqual);

  return accounts.find((a) => a?._id === accountId);
}
